import { makeAutoObservable, runInAction } from "mobx";
import { makePersistable } from "mobx-persist-store";
export default class FashCreativeStore {
  constructor() {
    makeAutoObservable(this);
    makePersistable(this, {
      name: "FashCreativeStore",
      properties: ["singleCatalogue", "collections", "categories", "themes"],
    });
  }
  singleCatalogue = {};
  collections = [];
  categories = [];
  themes = {};

  reset = () => {
    this.singleCatalogue = {};
    this.collections = [];
    this.categories = [];
    this.themes = {};
  };

  setSingleCatalogue = async (singleCatalogue) => {
    runInAction(async () => {
      this.singleCatalogue = singleCatalogue;
    });
  };
  setCollections = async (state) => {
    runInAction(async () => {
      this.collections = state;
    });
  };
  setCategories = async (state) => {
    runInAction(async () => {
      this.categories = state;
    });
  };

  setThemes = async (state) => {
    runInAction(async () => {
      this.themes = state;
    });
  };
}
